import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import DetailMenu from './DetailMenu';
import { startSetDetailView } from '../actions/globalState';
import DetailTabs from './DetailTabs';
import { Layout } from 'antd';
import PopulationType from './PopulationType';
import GeoType from './GeoType';
import GeoNameType from './GeoNameType';
import Dashboard from './economicProfile/Dashboard';

const { Header, Footer, Sider, Content } = Layout;

export class DetailContainer extends React.Component {
  onClick = () => {
    const detailView = false;
    this.props.startSetDetailView(detailView);
  }

  render() {
    const hasOverviewSummary = this.props.state.overviewSummary.length > 0
    let detailContent 
    if(hasOverviewSummary) {
      detailContent = 
      <Content>
        <Dashboard data={this.props.state}/>
      </Content>
    } else {
      detailContent = 
        <Content>
            <div className="detail-container__header">
              <GeoType />
              <GeoNameType type='details'/>
              <PopulationType />
            </div>
            <DetailTabs data={this.props.state}/>
        </Content>
    }
    return (
      <div className="detail-container">
        <Layout>

          <Layout>
            <Sider width={300}>
              <div className="back">
                <Button type="primary" size="large" onClick={() => this.onClick()}> Back to map explorer </Button>
              </div>
              <DetailMenu />
            </Sider>
            {detailContent}
          </Layout>
 
        </Layout>
    </div>
 
    )
  }
};

const mapStateToProps = (state) => ({
  state: state.globalState
});
const mapDispatchToProps = (dispatch) => ({
  startSetDetailView: (value) => dispatch(startSetDetailView(value))
});
export default connect(mapStateToProps, mapDispatchToProps)(DetailContainer);



// WEBPACK FOOTER //
// ./src/components/DetailContainer.js